import { getModule } from 'vuex-module-decorators';
import { ModuleDefinition } from './module';

export const DocumentModule = getModule(ModuleDefinition);
